<div class="mat-typography">
    <h1 *ngIf="data.title" mat-dialog-title>{{data.title}}</h1>
    <div mat-dialog-content>
      <p>{{data.content}}</p>
    </div>
    <div mat-dialog-actions>
      <button i18n mat-button color="primary" [mat-dialog-close]="true">Yes</button>
      <button i18n mat-button [mat-dialog-close]="false">No</button>
    </div>
  </div>
  